import axios from "../axiosInstance";
import { ReenrollRequestParams, ReenrollResponse } from "./types";

export const reenrollCourse = async (
  params: ReenrollRequestParams,
): Promise<ReenrollResponse> => {
  const response = await axios.post<ReenrollResponse>(
    `/api/learning-center/enrollments/${params.enrollmentId}/reactivate`,
  );
  return response.data;
};
